@if (isOpen) {
<div class="modal-backdrop-custom" (click)="close()">
  <div class="modal-container-custom" role="dialog" aria-modal="true" aria-labelledby="msm-title" (click)="$event.stopPropagation()">

    <div class="modal-header-custom">
      <div>
        <h2 class="modal-title-custom" id="msm-title">{{ title }}</h2>
        @if (subtitle) {
          <span class="modal-subtitle-custom">{{ subtitle }}</span>
        }
      </div>
      <button type="button" class="btn-close-custom" (click)="close()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="search-bar-custom">
      <input type="text" class="search-input-custom" [placeholder]="searchPlaceholder" [value]="search"
        aria-label="Search" (input)="onSearch($any($event.target).value)" />
      <span class="search-icon-custom" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </span>
    </div>

    <div class="filter-row">
      <button type="button" class="filter-chip" [class.filter-chip--on]="!showSelectedOnly"
        [attr.aria-pressed]="!showSelectedOnly" (click)="showSelectedOnly = false">
        All{{ total ? ' · ' + total : '' }}
      </button>
      <button type="button" class="filter-chip" [class.filter-chip--on]="showSelectedOnly"
        [attr.aria-pressed]="showSelectedOnly" [disabled]="!selectedCount" (click)="showSelectedOnly = true">
        Selected · {{ selectedCount }}
      </button>
    </div>

    <div class="modal-body-custom">
      @if (loading) {
        <div class="state-container">
          <div class="spinner-ring"><div></div><div></div><div></div><div></div></div>
          <p class="state-text">Loading…</p>
        </div>
      } @else if (error && !showSelectedOnly) {
        <div class="state-container">
          <p class="state-text state-text--error">{{ error }}</p>
          <button type="button" class="btn-secondary-custom" (click)="retry()">Try again</button>
        </div>
      } @else {
        <ul class="option-list-custom" role="listbox" aria-multiselectable="true" [attr.aria-label]="title">
          @for (item of visibleItems; track item.id) {
            <li class="option-item-custom" role="option" tabindex="0" [class.active]="isSelected(item.id)"
              [attr.aria-selected]="isSelected(item.id)" (click)="toggle(item)" (keydown)="onItemKeydown($event, item)">
              <span class="checkbox-custom" [class.checkbox-custom--on]="isSelected(item.id)" aria-hidden="true">
                @if (isSelected(item.id)) {
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"
                    stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                }
              </span>
              <span class="option-text-custom">
                <span class="option-label-custom">{{ item.label }}</span>
                @if (item.sublabel) {
                  <span class="option-sublabel-custom">{{ item.sublabel }}</span>
                }
              </span>
            </li>
          } @empty {
            <li class="state-container">
              @if (search.trim() && !showSelectedOnly) {
                <p class="state-text">No results for “<strong>{{ search }}</strong>”</p>
              } @else {
                <p class="state-text">{{ emptyText }}</p>
              }
            </li>
          }
        </ul>
        @if (canLoadMore) {
          <button type="button" class="load-more-custom" [disabled]="loadingMore" (click)="loadMore()">
            {{ loadingMore ? 'Loading…' : 'Load more (' + (total - items.length) + ' left)' }}
          </button>
        }
      }
    </div>

    <div class="modal-footer-custom">
      <span class="footer-count" aria-live="polite">{{ selectedCount }} selected</span>
      <div class="footer-actions">
        @if (selectedCount) {
          <button type="button" class="btn-link-custom" (click)="clear()">Clear</button>
        }
        <button type="button" class="btn-secondary-custom" (click)="close()">Cancel</button>
        <button type="button" class="btn-primary-custom" (click)="confirm()">Apply</button>
      </div>
    </div>

  </div>
</div>
}
